/**
 * 无响应切断 (#2744): stored as ms (null = off), edited as whole seconds.
 * Bounds come from the contract so the console and the server refuse the
 * same values.
 */
import {
  GUARANTEED_NO_RESPONSE_CUTOFF_MAX_MS,
  GUARANTEED_NO_RESPONSE_CUTOFF_MIN_MS,
  isGuaranteedNoResponseCutoffMs,
} from '@nadoutong/contracts';

export const CUTOFF_MIN_SECONDS = GUARANTEED_NO_RESPONSE_CUTOFF_MIN_MS / 1000;
export const CUTOFF_MAX_SECONDS = GUARANTEED_NO_RESPONSE_CUTOFF_MAX_MS / 1000;

/** The stored value, or null (off) for anything that is not a valid cutoff — e.g. an older server that omits the field. */
export function storedCutoffMs(value: unknown): number | null {
  return typeof value === 'number' && isGuaranteedNoResponseCutoffMs(value) ? value : null;
}

/** 「25 s」; a value set through the API in sub-second ms keeps its decimals. */
export function cutoffSecondsText(ms: number): string {
  return `${String(ms / 1000)} s`;
}

/** Whole seconds in range → ms; anything else → null (refuse, send nothing). */
export function parseCutoffSeconds(raw: string): number | null {
  const trimmed = raw.trim();
  if (!/^\d+$/.test(trimmed)) return null;
  const seconds = Number(trimmed);
  const ms = seconds * 1000;
  return Number.isSafeInteger(ms) && isGuaranteedNoResponseCutoffMs(ms) ? ms : null;
}
